const NoMatch = () => {
  return (
    <div>
      <p> No Page match the URL</p>
    </div>
  );
};

export default NoMatch;
